// src/components/NotFound.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  // Redirect to home page immediately
  return <Navigate to="/" replace />;
};

export default NotFound;